import Cookies from "js-cookie";
import { _token } from "./utils";


export const setToken = (token: string) =>
	Cookies.set(_token, token, { secure: true, sameSite: "strict" });

export const getToken = () => Cookies.get(_token);
export const clearToken = () => Cookies.remove(_token);